/*
 * /auth/logout (page)
 */
import { createFileRoute, useRouter } from "@tanstack/react-router"
import { useAuth } from "@psychology/auth/client"
import { Container, Page } from "@psychology/react-ui"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { appConfig } from "../../config/app-config"

export const Route = createFileRoute("/auth/logout")({
	component: AuthLogoutPage,
})

function AuthLogoutPage() {
	const { t } = useTranslation()
	const { signOut } = useAuth()
	const router = useRouter()

	async function handleSignOut() {
		await signOut()
		router.invalidate()
		router.navigate({
			to: appConfig.redirects.afterSignOutUrl,
			search: { tab: "login" },
			replace: true,
		})
	}

	useEffect(() => {
		handleSignOut()
	}, [])

	return (
		<Page>
			<Container className={"flex min-h-screen items-center justify-center"}>
				<div className="text-center">
					<h1 className="mb-4 text-2xl font-semibold">
						{t("auth.signingOut")}
					</h1>
					<p className="text-muted-foreground">{t("auth.redirectShortly")}</p>
				</div>
			</Container>
		</Page>
	)
}
